import { UpdateUser } from './update-user.entity';

export class CreateUser extends UpdateUser {
    Password: string;
    OrganisationId: string;
}
